

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/0.BWHruh4c.js","_app/immutable/chunks/disclose-version.BTC8Bk4r.js","_app/immutable/chunks/runtime.NVyxXVLy.js","_app/immutable/chunks/legacy.DKpsC3nd.js","_app/immutable/chunks/if.DkuB8BPo.js","_app/immutable/chunks/store.EL_7F1Fq.js","_app/immutable/chunks/stores.DmQQ1jkb.js","_app/immutable/chunks/entry.CYtqVooA.js","_app/immutable/chunks/index.DQ_X5mOz.js","_app/immutable/chunks/index-client.TDQqURXd.js"];
export const stylesheets = ["_app/immutable/assets/0.KBfFyqh2.css"];
export const fonts = [];
